import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { AirPathDirection } from "@domain/project/floorplan/air-path";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-air-path-menu",
  templateUrl: "./floorplan-air-path-menu.component.html",
  styleUrls: ["./floorplan-air-path-menu.component.scss"],
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
  standalone: true,
})
export class FloorplanAirPathMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;

  protected readonly tooltipTextAddExhaustAirPath: string = $localize`:@@floorplan.button.addExhaustAirPath:Neuen Abluftweg hinzufügen`;
  protected readonly tooltipTextAddSupplyAirPath: string = $localize`:@@floorplan.button.addSupplyAirPath:Neuen Zuluftweg hinzufügen`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  addExhaustAirPath() {
    this.addToFloorplan(AirPathDirection.EXHAUST_AIR);
  }

  addSupplyAirPath() {
    this.addToFloorplan(AirPathDirection.SUPPLY_AIR);
  }

  dragExhaustAirPath() {
    this.dragDropService.setDragged({ type: DraggedItemType.EXHAUST_AIR, config: AirPathDirection.EXHAUST_AIR });
  }

  dragSupplyAirPath() {
    this.dragDropService.setDragged({ type: DraggedItemType.SUPPLY_AIR, config: AirPathDirection.SUPPLY_AIR });
  }

  protected updateAirPathsItemTextVisibility(visible: boolean) {
    this.floorplanState.updateAirPathsItemTextVisibility(visible);
  }

  private addToFloorplan(direction: AirPathDirection) {
    this.floorplanService.addAirPath(direction);
  }
}
